// menuItems.js
import dashboard from './dashboard';

const menuItemsByRole = {
  admin: [dashboard],
};

export default menuItemsByRole;
